export default {
  namespaced: true,
  state: {
    modules: JSON.parse(localStorage.getItem('modules')),
    permissions: JSON.parse(localStorage.getItem('permissions')),
    roles: JSON.parse(localStorage.getItem('roles')),
    site: localStorage.getItem('site')
  },
  mutations: {
    modules(state, modules) {
      state.modules = modules
      localStorage.setItem('modules', JSON.stringify(modules))
    },
    permissions(state, permissions) {
      state.permissions = permissions
      localStorage.setItem('permissions', JSON.stringify(permissions))
    },
    roles(state, roles) {
      state.roles = roles
      localStorage.setItem('roles', JSON.stringify(roles))
    },
    site(state, site) {
      state.site = site
      localStorage.setItem('site', site)
    },
    reset(state) {
      state.modules = null
      state.permissions = null
      state.roles = null
      state.site = null

      localStorage.removeItem('modules')
      localStorage.removeItem('permissions')
      localStorage.removeItem('roles')
      localStorage.removeItem('site')
    }
  },
  getters: {
    permissions: state => {
      return state.permissions
    },
    roles: state => {
      return state.roles
    },
    menuitems: state => {
      let menuitems = []
      if (state.modules) {
        for (let i = 0; i < state.modules.length; i++) {
          let module = state.modules[i]
          if (Array.isArray(module.menuitems) && module.menuitems.length > 0) {
            menuitems = menuitems.concat([
              {
                id: module.id,
                title: true,
                name: module.name,
                classname: '',
                wrapper: {
                  element: 'span',
                  attributes: module.attributes
                }
              }
            ])
            menuitems = menuitems.concat(module.menuitems)
          }
        }
        return menuitems
      }
      return null
    },
    modules: state => {
      return state.modules
    },
    site: state => {
      return state.site
    }
  }
}
